import React, {useMemo, useState, useEffect} from 'react';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {isValidObject} from '../../../Assets/functions/functions';
import {isValidILMobileExtended} from 'app/utilities/StringHelpers/StringHelpers';

const MobileInputForm = ({title, subtitle, additionalTextInputProps = {}, placeholder, errorMessage = '', btnText, onClickCallback}) => {
  const [showError, setShowError] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleOnChange = (e) => {
    const value = e.target.value;
    const isValid = isValidILMobileExtended(value);

    setShowError(!isValid && value.length > 0);

    if (isValid) {
      setInputValue(value);
    }
  };

  const handleOnClick = () => {
    if (!showError && inputValue) {
      onClickCallback(inputValue);
    }
  };

  return (
    <div className='mobile-input-form-container'>
      <div className='mobile-input-form'>
        <div className='mobile-input-form-upper-part'>
          <div className='titles-container'>
            {title && <span className='title'>{title}</span>}
            {subtitle && <span className='sub-title'>{subtitle}</span>}
          </div>
          <TextInput
            {...additionalTextInputProps}
            placeholder={placeholder}
            onChange={handleOnChange}
            error={showError ? errorMessage : ''}
          />
        </div>
        <div className={`btn-container ${showError ? 'has-error' : ''}`}>
          <BtnSubmit text={btnText} onclick={handleOnClick} />
        </div>
      </div>
    </div>
  );
};
export default MobileInputForm;
